import _ from 'lodash'
import CommonState, { CmNotification, ErrorStatus, NotificationLevel } from './state'

export interface AddNotificationRequest {
  type?: string,
  level?: NotificationLevel,
  message: string,
  timeout?: number
}

/**
 * 通知を追加する。
 * @param {CommonState} state - 通知の保存場所
 * @param {CmNotification} notification - 通知
 */
export function addNotification(state: CommonState, request: AddNotificationRequest): void {
  if (request.type) {
    // 同じタイプのメッセージは1つしか存在できない
    state.notifications = state.notifications.filter(n => n.type !== request.type)
  }
  const notification = Object.assign(
    <CmNotification>{
      level: 'primary'
    },
    request,
    {
      id: _.uniqueId('notification_'),
      _isTimerRunning: false
    })
  state.notifications.unshift(notification)
}

/**
 * 通知を全て削除する
 * @param {CommonState} state - 通知の保存場所
 */
export function clearNotifications(state: CommonState): void {
  state.notifications = []
}

/**
 * 指定された通知を削除する。
 * @param {CommonState} state - 通知の保存場所
 * @param {CmNotification} notification - 消す通知
 */
export function removeNotification(state: CommonState, notification: CmNotification | string): void {
  const id = _.isString(notification) ? notification : notification.id
  state.notifications = state.notifications.filter(n => n.id !== id)
}

/**
 * 指定された種類の通知を削除する。
 * @param {CommonState} state - 通知の保存場所
 * @param {string} type - 通知の種類
 */
export function removeNotificationByType(state: CommonState, type: string): void {
  state.notifications = state.notifications.filter(n => n.type !== type)
}

export function setErrorStatus(state: CommonState, errorStatus: ErrorStatus): void {
  state.errorStatus = errorStatus
}

export default {
  addNotification,
  clearNotifications,
  removeNotification,
  removeNotificationByType,
  setErrorStatus
}
